// src/components/PaymentModal.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PaymentModal = ({ isOpen, onClose }) => {
  // Состояние шага ("form" или "qr")
  const [step, setStep] = useState("form");

  // Состояние формы
  const [formData, setFormData] = useState({
    amount: '',
    fullName: '',
    email: '',
    offerAgreement: false,
    privacyAgreement: false,
  });

  // Состояние валидности формы
  const [isValid, setIsValid] = useState(false);
  const [qrData, setQrData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const amountValid = Number(formData.amount) > 0;
    const fullNameValid = formData.fullName.trim() !== '';
    const emailValid = formData.email.includes('@');
    const agreementsValid = formData.offerAgreement && formData.privacyAgreement;
    setIsValid(amountValid && fullNameValid && emailValid && agreementsValid);
  }, [formData]);

  useEffect(() => {
    if (!isOpen) {
      setStep("form");
    }
  }, [isOpen]);

  // Обработчик изменений полей
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!isValid) return;
  setError('');
  setQrData(null);
  try {
    // Отправляем POST-запрос, передавая сумму и email в теле запроса
    const response = await axios.post('/cheki-api/api/create-payment', {
      amount: formData.amount,
      fullName: formData.fullName,
      email: formData.email,
    });
    
    // Извлекаем qr_img и qr_link из ответа
    const { qr_img, qr_link } = response.data.results;
    setQrData({ qr_img, qr_link });
    setStep("qr");

  } catch (err) {
      if (err.response) {
        const status = err.response.status;
        const data = err.response.data;
        setError(`Ошибка ${status}: ${JSON.stringify(data)}`);
      } else if (err.request) {
        setError('Нет ответа от сервера. Проверьте сетевое соединение.');
      } else {
        setError(`Ошибка запроса: ${err.message}`);
      }
  }
  };


  // Обработчик возврата к форме
  const handleBack = () => {
    setStep("form");
  };

  // Если модальное окно закрыто, не рендерим
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="modal"
      id="paymentModal"
      style={{ display: 'flex' }}
      onClick={onClose}
    >
      <div
        className="modal-content"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          className="close"
          type="button"
          onClick={onClose}
          aria-label="Закрыть форму оплаты"
        >
          &times;
        </button>
        
        {step === "form" && (
          <form className="payment-form" onSubmit={handleSubmit}>
            <div className="form-container">
              <div className="form-left">
                <img
                  src={process.env.PUBLIC_URL + '/images/payment/payment-modal-3d.webp'}
                  alt="Оплата"
                  className="payment-image"
                />
              </div>
              <div className="form-right">
                <img
                  className="payment-mobile-logo"
                  src={process.env.PUBLIC_URL + '/images/logo/shoptop_logo_3d_icon_transparent.png'}
                  alt=""
                  aria-hidden="true"
                />
                <h3>Форма оплаты</h3>

                <div className="input-group">
                  <label htmlFor="amount">Введите сумму (руб.):</label>
                  <input
                    type="number"
                    id="amount"
                    name="amount"
                    value={formData.amount}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="full-name">ФИО (на кого оформлен заказ):</label>
                  <input
                    type="text"
                    id="full-name"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="email">Email (куда придет чек):</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="agreements">
                  <label>
                    <input
                      type="checkbox"
                      id="offer-agreement"
                      name="offerAgreement"
                      checked={formData.offerAgreement}
                      onChange={handleChange}
                      required
                    />
                    <span className="agreement-text">
                      Я согласен с <a href="/oferta">Договором оферты</a>
                    </span>
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      id="privacy-agreement"
                      name="privacyAgreement"
                      checked={formData.privacyAgreement}
                      onChange={handleChange}
                      required
                    />
                    <span className="agreement-text">
                      Я согласен с <a href="/privacy">Политикой конфиденциальности</a>
                    </span>
                  </label>
                </div>

                <button
                  type="submit"
                  id="submit-button"
                  className="submit-button"
                  disabled={!isValid}
                >
                  Оплатить
                </button>
              </div>
            </div>
          </form>
        )}

        {step === "qr" && (
          <div className="qr-result" style={{ textAlign: 'center', padding: '20px' }}>
            <h4>Сканируйте QR-код для оплаты:</h4>
            {qrData ? (
              <img
                src={qrData.qr_img}
                alt="QR Code"
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            ) : (
              <p>QR-код не найден</p>
            )}
            <div style={{ marginTop: '10px' }}>
            <a
              href={qrData.qr_link}
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#1b32a2', textDecoration: 'underline', fontSize: '16px' }}
            >
              Или воспользуйтесь ссылкой
            </a>
          </div>
            <button
              type="button"
              onClick={handleBack}
              style={{
                marginTop: '20px',
                backgroundColor: '#1b32a2',
                color: '#fff',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Назад
            </button>
          </div>
        )}

        {error && (
          <div className="error" style={{ color: 'red', textAlign: 'center' }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;
